import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined, RocketOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    const result = await login(values.username, values.password);
    
    if (result.success) {
      message.success('登录成功！');
      navigate('/dashboard');
    } else {
      message.error(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      {/* 背景装饰 */}
      <div className="bg-decoration bg-decoration-1" />
      <div className="bg-decoration bg-decoration-2" />
      <div className="bg-decoration bg-decoration-3" />
      <div className="bg-decoration bg-decoration-4" />
      <div className="bg-decoration bg-decoration-5" />
      <div className="bg-decoration bg-decoration-6" />
      <div className="bg-decoration bg-decoration-7" />
      
      <Card className="login-card">
        <div className="login-header">
          <div className="login-icon">
          </div>
          <Title level={2} className="login-title">
            星火反作弊系统
          </Title>
          <Text className="login-subtitle">
            安全登录，智能防护
          </Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
          className="login-form"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名!' }]}
          >
            <Input
              prefix={<UserOutlined className="input-icon" />}
              placeholder="用户名"
              className="login-input"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码!' }]}
          >
            <Input.Password
              prefix={<LockOutlined className="input-icon" />}
              placeholder="密码"
              className="login-input"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="login-button"
            >
              登录
            </Button>
          </Form.Item>
        </Form>
        
      </Card>
    </div>
  );
};

export default Login;
